import { useParams } from 'react-router-dom';
import { Button } from 'antd';

import { usePutRequest, useUserRole } from 'hooks';

import { SnapDetails } from 'codegen';

import { initSnapSuccessAction, snapStore } from '../../../store';

export const DescalateButton = () => {
  const isEscalated = snapStore((state) => state.snapBooleanStatuses.isEscalated);

  const { snapId } = useParams();

  const [handleDeescalate, { loading }] = usePutRequest<SnapDetails>({
    url: `/snaps/${snapId}/corrections/deescalate`,
    options: {
      onSuccess: ({ data }) => initSnapSuccessAction(data),
    },
  });

  const { isAdmin } = useUserRole();

  if (!isEscalated || !isAdmin) {
    return null;
  }

  return (
    <Button
      danger
      size='small'
      loading={loading}
      onClick={() => handleDeescalate()}
    >
      Descalate
    </Button>
  );
};
